import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../../utils/api-endpoints.const';
import { HttpClient } from '@angular/common/http';
import { OfferingListResponse } from '../../interfaces/fund-offering/fund-offering-interface';
import { DropdownItem } from '../../interfaces/shared/dropdown-item/dropdown-item';
import {
  offerDetailsResponse,
  offerCreationRequest,
} from '../../interfaces/fund-offering/fund-offering-interface';
import { ApiResponse } from '../../interfaces/shared/fund/api-response';
@Injectable({
  providedIn: 'root',
})
export class FundOffering {
  private readonly http = inject(HttpClient);

  getOfferingPaymentOptions(): Observable<ApiResponse<DropdownItem[]>> {
    return this.http.get<ApiResponse<DropdownItem[]>>(
      `${API_ENDPOINTS.LOOKUPS}/payment_options`
    );
  }

  createOffering(
    fundUuid: string,
    offeringData: offerCreationRequest
  ): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      `${API_ENDPOINTS.FUND_OFFERING(fundUuid)}`,
      offeringData
    );
  }

  updateOffering(
    fundUuid: string,
    offeringUuid: string,
    offeringData: offerCreationRequest
  ): Observable<ApiResponse<unknown>> {
    return this.http.post<ApiResponse<unknown>>(
      `${API_ENDPOINTS.FUND_OFFERING_DETAILS(fundUuid, offeringUuid)}`,
      offeringData
    );
  }

  getOffersList(
    fundUuid: string,
    page: number,
    perPage: number
  ): Observable<OfferingListResponse> {
    const params = { page: page, per_page: perPage };

    return this.http.get<OfferingListResponse>(
      API_ENDPOINTS.FUND_OFFERING(fundUuid),
      { params }
    );
  }

  getOfferingDetails(
    fundUuid: string,
    offeringUuid: string
  ): Observable<offerDetailsResponse> {
    return this.http.get<offerDetailsResponse>(
      `${API_ENDPOINTS.FUND_OFFERING_DETAILS(fundUuid, offeringUuid)}`
    );
  }
}
